import "./datatables.scss"
import React from "react"
import PropTypes from "prop-types"
import MDBDataTable from "../../components/Common/MDBDataTable"
import { Row, Col, Card, CardBody, CardTitle, Spinner } from "reactstrap"

const LatestBlockedOrdersList = React.memo(({
    orders,
    title = "Veeper Analyzed",
    option = [10, 20, 30, 40, 60, 80, 100, 200],
    default_entries = 200,
    displayEntries = true,
    searching = true,
    paging = true,
    loading = false
}) => {
    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="mdi mdi-account-group-outline font-18 mr-2"></i> {title}
                        </CardTitle>
                        <CardBody>
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <>
                                    <style>{`
                                        .table-fixed-columns-wrapper {
                                            overflow-x: auto;
                                            width: 100%;
                                        }
                                        .table-fixed-columns-wrapper .table-responsive {
                                            overflow-x: visible !important;
                                        }
                                        .table-fixed-columns-wrapper .table-fixed-columns table {
                                            table-layout: auto;
                                            width: 100% !important;
                                            min-width: max-content;
                                        }
                                        .table-fixed-columns-wrapper .table-fixed-columns table thead th,
                                        .table-fixed-columns-wrapper .table-fixed-columns table tbody td {
                                            white-space: nowrap;
                                            min-width: max-content;
                                        }
                                    `}</style>
                                    <div className="table-fixed-columns-wrapper">
                                        <div className="table-fixed-columns">
                                            <MDBDataTable
                                                bordered
                                                data={orders}
                                                entriesOptions={option}
                                                entries={default_entries}
                                                displayEntries={displayEntries}
                                                searching={searching}
                                                paging={paging}
                                                theadColor="primary"
                                                tbodyColor="light"
                                                hover={true}
                                                sortable={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
})

LatestBlockedOrdersList.displayName = 'LatestBlockedOrdersList'

LatestBlockedOrdersList.propTypes = {
    orders: PropTypes.shape({
        columns: PropTypes.arrayOf(PropTypes.object),
        rows: PropTypes.arrayOf(PropTypes.object),
    }),
    title: PropTypes.string,
    option: PropTypes.arrayOf(PropTypes.number),
    default_entries: PropTypes.number,
    displayEntries: PropTypes.bool,
    searching: PropTypes.bool,
    paging: PropTypes.bool,
    loading: PropTypes.bool,
}

export default LatestBlockedOrdersList
